import type { ConfigProviderProps } from "antd/lib/config-provider";
import { buildTheme, ThemeMode } from "./theme";

/** Compact by default — this is a dense internal tool, not a marketing site.
 *  `componentSize: "large"` was the single biggest source of the old app's
 *  airy, unserious feel. */
export const buildConfig = (mode: ThemeMode): ConfigProviderProps => ({
  componentSize: "middle",
  theme: buildTheme(mode),
});

/** Back-compat export for anything still importing `config` directly. */
export const config: ConfigProviderProps = buildConfig("light");
